module.exports = __webpack_public_path__ + "static/img/features.0135c9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v3/img/features.png
// module id = ve3r
// module chunks = 10